module.exports = __webpack_public_path__ + "assets/img/client-logo-ivory-mono.4d1639bd.png";